module.exports = "0.8.5";



//////////////////
// WEBPACK FOOTER
// ./~/dagre/lib/version.js
// module id = 1713
// module chunks = 0